 import React from 'react';
import DatePicker from "react-datepicker";
import { formatDate } from '../common/helper'

import "react-datepicker/dist/react-datepicker.css";

class DatetimePick extends React.Component {
        constructor (props) {
          super(props)
          this.state = {
             startDate: new Date()
          };
          this.handleChange = this.handleChange.bind(this);
        }

        handleChange(date) {
          this.setState({
            startDate: date
          });
          const setStartDate = formatDate(this.props, new Date(this.state.startDate), 3)
          alert(setStartDate)
        }

        render() {
          return (
                <div className="container" style={{marginTop:"20px"}}>
                    <DatePicker
                        selected={this.state.startDate}
                        onChange={this.handleChange}
                    />
                </div>
          )
        }
      }
export default DatetimePick;

